import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-vbaspaltenkopieren',
  templateUrl: './page-vbaspaltenkopieren.component.html',
  styleUrls: ['./page-vbaspaltenkopieren.component.scss']
})
export class PageVBASpaltenkopierenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
